import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/Authcontext';

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();

  if (!user) {
    // Redirect to login with return URL
    return <Navigate to="/login" state={{ returnUrl: location.pathname }} replace />;
  }

  return children;
};

export default ProtectedRoute;